export class ProduktionsmallarTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static validation = {
        mandatory: "Fält kan inte vara tomt",
        namnAlreadyTaken: "Namnet är upptaget",
        missingMallnamn: "Mallnamn får inte vara tomt",
        maxLengthError: "För många tecken har angivits",
        missingHandelssortiment: "Handelssortiment får inte vara tomt"
    };
    // eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        innehall: "Innehåll",
        standardNamnPaMall: "",
        mallNamn: "Mallnamn",
        angeMallNamn: "Ange namn",
        angeProduktionsomrade: "Ange produktionsområde",
        borttagningConfirmHeader: "Borttagning av mall",
        borttagningConfirmBody: "Är du säker på att du vill ta bort mallen?",
        lamnaModalHeader: "Osparade förändringar",
        lamnaModalBody: "En eller flera mallar har osparade förändringar.",
        mallenBorttagen: "Produktionsmall togs bort",
        mallenSparades: "Produktionsmall sparades",
        produktionsomrade: "Produktionsområde",
        produktionsmalFilter: "Endast med produktionsmål",
        nyMall: "Ny mall",
        dialogHeader: "Redigera",
        redigeraForkalkylsmall: "Redigera produktionsmall",
        skapaProduktionssmall: "Skapa produktionsmall"
    };
}
